/* pdp-editorial.js: variant switching, copy-to-clipboard, sound toggle and the sticky add-to-cart bar. */
(function () {
  'use strict';
  // Several product sections each include this file, so it can load more than once on a page.
  // Run once, otherwise every click handler is attached multiple times and cancels itself out.
  if (window.__pdpEditorialInit) return;
  window.__pdpEditorialInit = true;
  function init() {
    var root = document.querySelector('[data-pdp]');
    if (!root) return;

    // Claude mark filter (keeps only the light starburst of the logo file)
    if (!document.getElementById('pdp-claude-mark')) {
      var ns = 'http://www.w3.org/2000/svg';
      var svg = document.createElementNS(ns, 'svg'); svg.setAttribute('width', '0'); svg.setAttribute('height', '0'); svg.setAttribute('style', 'position:absolute'); svg.setAttribute('aria-hidden', 'true');
      svg.innerHTML = '<filter id="pdp-claude-mark" color-interpolation-filters="sRGB"><feColorMatrix type="matrix" values="0 0 0 0 1  0 0 0 0 1  0 0 0 0 1  1.7 5.7 .58 0 -6"/></filter>';
      document.body.appendChild(svg);
    }

    var buy = root.querySelector('[data-pdp-buy]');
    var idInput = root.querySelector('[data-pdp-id]');
    var addBtn = root.querySelector('[data-pdp-add]');
    var addLabel = root.querySelector('[data-pdp-add-label]');
    var barBtn = document.querySelector('[data-pdp-bar-add]');
    var bar = document.querySelector('[data-pdp-bar]');

    // variants
    var vjson = root.querySelector('[data-pdp-variants]');
    if (vjson && idInput) {
      var variants = []; try { variants = JSON.parse(vjson.textContent); } catch (e) {}
      var opts = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-opt]'));
      var money = function (c) { return '$' + (c / 100).toFixed(c % 100 ? 2 : 0).replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
      var sync = function () {
        var picked = {};
        opts.forEach(function (o) { if (o.checked) picked['option' + o.getAttribute('data-pdp-opt')] = o.value; });
        var v = variants.filter(function (x) { return Object.keys(picked).every(function (k) { return x[k] === picked[k]; }); })[0];
        if (!v) return;
        idInput.value = v.id; idInput.disabled = !v.available;
        Array.prototype.forEach.call(document.querySelectorAll('[data-pdp-price]'), function (p) { p.textContent = money(v.price); });
        [addBtn, barBtn].forEach(function (b) { if (b) b.disabled = !v.available; });
        var t = v.available ? 'Add to cart' : 'Sold out';
        if (addLabel) addLabel.textContent = t;
        if (barBtn) barBtn.firstElementChild.textContent = t;
        try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
      };
      opts.forEach(function (o) { o.addEventListener('change', sync); });
    }

    // sticky bar: shown once the main button has scrolled above the viewport
    if (bar && addBtn) {
      var ticking = false;
      var check = function () {
        ticking = false;
        var gone = addBtn.getBoundingClientRect().bottom < 0;
        var ft = document.querySelector('.shopify-section-group-footer-group, footer, #shopify-section-footer');
        if (ft && ft.getBoundingClientRect().top < window.innerHeight - 40) gone = false;
        var nl = document.querySelector('.newsletter, [class*="newsletter"], .footer');
        if (nl && nl.getBoundingClientRect().top < window.innerHeight - 80) gone = false;
        if (bar.classList.contains('is-on') === gone) return;
        bar.classList.toggle('is-on', gone);
        bar.setAttribute('aria-hidden', gone ? 'false' : 'true');
        if (barBtn) barBtn.tabIndex = gone ? 0 : -1;
      };
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
      window.addEventListener('resize', check);
      check();
    }
    if (barBtn && addBtn) barBtn.addEventListener('click', function () { addBtn.click(); });

    // copy activation phrase
    var copy = document.querySelector('[data-pdp-copy]'), phrase = document.querySelector('[data-pdp-phrase]');
    if (copy && phrase) {
      copy.addEventListener('click', function () {
        var text = phrase.textContent.trim();
        var done = function () { copy.textContent = 'Copied'; setTimeout(function () { copy.textContent = 'Copy'; }, 1800); };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(done, function () {});
        else { var ta = document.createElement('textarea'); ta.value = text; document.body.appendChild(ta); ta.select(); try { document.execCommand('copy'); done(); } catch (e) {} document.body.removeChild(ta); }
      });
    }

    // video sound
    var snd = document.querySelector('[data-pdp-sound]'), vid = document.querySelector('.pdp-video video');
    if (snd && vid) snd.addEventListener('click', function () {
      vid.muted = !vid.muted;
      if (vid.paused) { var p = vid.play(); if (p && p.catch) p.catch(function () {}); }
      snd.textContent = vid.muted ? 'Sound off' : 'Sound on';
      snd.setAttribute('aria-pressed', vid.muted ? 'false' : 'true');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
